import { API_URL } from "../../../../Config/api";
import styled from "styled-components";
import { Link, useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import {
  faLocationDot,
  faUser,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";
import Container from "../../../../Components/Container";
import FlexInColumn from "../../../../Components/FlexInColumn";
import FlexInRow from "../../../../Components/FlexInRow";
import PageTitle from "../../../../Components/PageTitle";

import IconFile from "../../../../Assets/Images/icon-awesome-file-alt.svg";
import IconSubscribe from "../../../../Assets/Images/icon-partilhar.svg";
import IconSeeMore from "../../../../Assets/Images/icon-saber-mais.svg";
import IconShare from "../../../../Assets/Images/icon-partilhar.svg";
import IconReturn from "../../../../Assets/Images/icon-voltar.svg";
import { Button, notification, Tag } from "antd";
import Item from "antd/es/list/Item";

const Wrapper = styled.main`
  background-color: #ffffff;
  color: #000000;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: inherit;
  text-align: left;
  width: 100%;
  margin-top: 7.813vw;

  .preview a {
    display: contents !important;
  }

  .preview .u-row-container img {
    max-width: 100% !important;
  }

  .preview .u-row {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 auto !important;
  }

  .main-img-congresso {
    max-height: 500px;
    width: auto;
    display: block;
    margin: 0 auto;
    object-fit: cover;
  }

  img {
    //width: 100%;
  }

  .preview li {
    font-size: auto !important;
  }

  .preview img {
    max-width: 100%;
    height: auto;
    width: auto !important;
  }

  .preview li img {
    flex-shrink: 0;
  }

  .preview img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .preview {
    all: revert;
  }

  .preview *:not(.u-row) {
    all: revert;
  }

  .preview .u-row {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 auto !important;
  }

  ul {
    width: 8.333vw;
    padding: 0;
    width: 100%;
    list-style-type: disc !important;
    list-style-position: outside !important;
    padding-left: 1.5rem !important;
    margin-left: 0 !important;
    color: #000;
  }
  ul li {
    list-style-type: disc !important;
    display: list-item !important;
    font-size: 16px;
  }

  li {
    align-items: center;
    justify-content: flex-start;
    display: flex;
    flex-direction: row;
    gap: 0.729vw;
    text-align: left;
    font-size: 1.146vw;
    line-height: 1.51vw;
    letter-spacing: 0px;
    opacity: 1;

    img {
      width: 1.667vw;
    }
  }

  li a {
    color: #f88436;
    text-decoration: none;
    display: contents !important;
  }

  .event__content h2 {
    font-size: 22px;
  }

  .event__content {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    margin: 0 0 20px 0;
  }

  .event__content a {
    display: initial !important;
    color: rgb(12, 17, 81);
  }

  .event__content img {
    max-width: 60%;
    display: block;
    margin-right: auto;
  }

  .event__content iframe {
    height: 30vw;
    width: 60%;
  }

  .event__content ul {
    width: 100%;
  }

  .icon {
    margin-right: 8px;
  }

  .icon-file {
    width: 3.438vw;
  }

  .share {
    cursor: pointer;
    color: ${(props) => props.theme.orange};
  }

  .event-content {
    width: 100%;
  }

  @media (max-width: 992px) {
    margin-top: 120px;

    .event__content iframe {
      height: 400px;
      width: 100%;
    }

    .preview p,
    .preview li {
      font-size: auto !important;
      line-height: normal !important;
    }
  }
`;

const Tab = styled.div`
  margin-bottom: 10px;
  width: 100%;

  span {
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.51vw;
    letter-spacing: 0px;
    color: #0c1151;
    opacity: 1;
  }

  @media (max-width: 992px) {
    margin-bottom: 05px;

    span {
      font-size: 18px;
      line-height: 4.444vw;
    }
  }

  @media (min-width: 1920px) {
    span {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;

const Title = styled.h3`
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  line-height: inherit;
  letter-spacing: 0px;
  color: #0c1151;
  opacity: 1;

  @media (max-width: 992px) {
    font-size: 3.333vw;
    line-height: 4.444vw;
  }

  @media (min-width: 1920px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

const SectionShareContent = styled.section`
  margin-top: 30px;
  padding: 3.646vw 0;
  background: #d6d7e2 0% 0% no-repeat padding-box;
  opacity: 1;

  .title {
    text-align: center;
    font-size: 2.083vw;
    font-weight: bold;
    line-height: 2.5vw;
    letter-spacing: 0px;
    color: #0c1151;
    text-transform: uppercase;
    opacity: 1;
  }

  .text {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: inherit;
    letter-spacing: 0px;
    color: #0c1151;
    opacity: 1;
    margin-bottom: 4.167vw;
  }

  @media (min-width: 1920px) {
    .title {
      font-size: 40px;
      line-height: 48px;
    }

    .text {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;

const SectionMembers = styled.section``;

const SectionMembersContent = styled.div`
  background-color: #ffffff;
  border: 3px solid #0c1151;
  border-radius: 1.042vw;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "image title"
    "image text"
    "image cta";
  opacity: 1;
  overflow: hidden;

  @media (min-width: 1920px) {
    border-radius: 10px;
  }
`;

const SectionMembersImage = styled.div`
  border-radius: 1.042vw 0px 0px 1.042vw;
  grid-area: image;
  overflow: hidden;

  @media (min-width: 1920px) {
    border-radius: 10px 0px 0px 10px;
  }
`;

const SectionMembersTitle = styled.h3`
  grid-area: title;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  line-height: inherit;
  letter-spacing: 0px;
  color: #0c1151;
  opacity: 1;
  margin: 1.042vw;
  place-self: flex-end flex-start;

  @media (max-width: 992px) {
    font-size: 3.333vw;
    line-height: 4.444vw;
  }

  @media (min-width: 1920px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

const SectionMembersText = styled.p`
  grid-area: text;
  text-align: left;
  font-size: 0.938vw;
  line-height: 1.25vw;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin: 0 1.042vw;
  place-self: center flex-start;

  @media (max-width: 992px) {
    font-size: 2.222vw;
    line-height: 3.333vw;
  }

  @media (min-width: 1920px) {
    font-size: 22px;
    line-height: 29px;
  }
`;

const SectionMembersCta = styled.a`
  grid-area: cta;
  text-align: left;
  font-size: 0.938vw;
  font-weight: bold;
  line-height: 1.25vw;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  background: #090d3d 0% 0% no-repeat padding-box;
  border-radius: 0.417vw;
  opacity: 1;
  transition: 0.3s ease;
  margin: 1.042vw;
  place-self: flex-end flex-start;
  padding: 0.521vw 1.563vw;
  text-decoration: none;
  align-items: center;
  justify-content: center;

  :hover {
    background-color: #8688a8;
    color: #e5e5e5;
  }

  @media (max-width: 992px) {
  }

  @media (min-width: 1920px) {
    border-radius: 10px;
    font-size: 22px;
    line-height: 29px;
    margin: 10px;
  }
`;

export default function Apresentacao(props) {
  const session_storage = JSON.parse(localStorage.getItem("session_data"));

  const { slug } = useParams();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [disclaimer, setDisclaimer] = useState(false);

  const [apresentacao, setApresentacao] = useState([]);
  const tipoUtilizador =
    session_storage?.all_data?.user_session?.tipo_utilizador || null;

  const isAdmin = tipoUtilizador == "admin";
  const isSocio = tipoUtilizador == "socio_aprovado";
  const isNaoSocio = tipoUtilizador == "nao_socio";
  const isNaoRegistado = !tipoUtilizador;

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  function removeLinks(html) {
    return html.replace(/<a\b[^>]*>(.*?)<\/a>/gi, "$1");
  }

  const getApresentacao = (myApresentacao) => {
    let apresentacaoAMostrar = myApresentacao;

    // 🔐 Validação de visibilidade
    if (!podeVerApresentacao(apresentacaoAMostrar)) {
      apresentacaoAMostrar.descricao = removeLinks(
        apresentacaoAMostrar.descricao
      );
      setDisclaimer(true);
    }

    apresentacaoAMostrar.url = apresentacaoAMostrar.imagem_destaque
      ? "https://api.spap.pt/apresentacoes/" +
        apresentacaoAMostrar.id +
        "/" +
        apresentacaoAMostrar.imagem_destaque
      : "https://api.spap.pt/clubes/clube-estudo-default.svg";
    apresentacaoAMostrar.data = formatDateRange(
      apresentacaoAMostrar.start_event,
      apresentacaoAMostrar.end_event
    );
    setApresentacao(apresentacaoAMostrar);
  };

  const formatDateRange = (start, end) => {
    const parseDate = (str) => {
      if (!str || str == "null") return null;
      const [day, month, year] = str.split("/");
      return new Date(`${year}-${month}-${day}`);
    };

    const formatDay = (date) => String(date.getDate()).padStart(2, "0");
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    const startDate = parseDate(start);
    const endDate = parseDate(end);

    if (!startDate && !endDate) return "";
    if (!startDate && endDate)
      return `Até ${formatDay(endDate)} de ${
        months[endDate.getMonth()]
      } de ${endDate.getFullYear()}`;
    if (startDate && !endDate)
      return `A partir de ${formatDay(startDate)} de ${
        months[startDate.getMonth()]
      } de ${startDate.getFullYear()}`;

    const sameMonth = startDate.getMonth() === endDate.getMonth();
    const sameYear = startDate.getFullYear() === endDate.getFullYear();

    if (sameMonth && sameYear) {
      return `${formatDay(startDate)} a ${formatDay(endDate)} de ${
        months[endDate.getMonth()]
      } de ${endDate.getFullYear()}`;
    } else if (!sameMonth && sameYear) {
      return `${formatDay(startDate)} de ${
        months[startDate.getMonth()]
      } a ${formatDay(endDate)} de ${
        months[endDate.getMonth()]
      } de ${endDate.getFullYear()}`;
    } else {
      return `${formatDay(startDate)} de ${
        months[startDate.getMonth()]
      } de ${startDate.getFullYear()} a ${formatDay(endDate)} de ${
        months[endDate.getMonth()]
      } de ${endDate.getFullYear()}`;
    }
  };

  useEffect(() => {
    fetch(
      `${API_URL}/get-apresentacao/` + slug.split("-").pop(),
      {
        method: "GET",
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar apresentacaos");
        }
        return response.json();
      })
      .then((data) => {
        if (data.length === 0) {
          console.log("nenhuma apresentacao");
        }
        getApresentacao(data.apresentacao);
      })
      .catch((error) => console.error(error));
  }, []);

  const handleShare = (link) => {
    navigator.clipboard.writeText(link);
    notification.info({ description: "Link copiado: " + link });
  };

  const podeVerApresentacao = (item) => {
    console.log(item);
    const nenhumAtivo =
      item.show_socios == 0 &&
      item.show_nao_socios == 0 &&
      item.show_nao_registados == 0;

    const todosAtivos =
      item.show_socios == 1 &&
      item.show_nao_socios == 1 &&
      item.show_nao_registados == 1;

    // Se nenhum switch estiver ativo → mostrar a todos
    if (isAdmin || nenhumAtivo || todosAtivos) return true;

    if (isSocio && item.show_socios == 1) return true;
    if (isNaoSocio && item.show_nao_socios == 1) return true;
    if (isNaoRegistado && item.show_nao_registados == 1) return true;

    return false;
  };

  const getHtml = () => {
    if (apresentacao.editor) {
      const content = apresentacao.editor.content;

      // se já for objeto
      if (typeof content === "object") {
        return content.html;
      }

      // se for string
      if (typeof content === "string") {
        return JSON.parse(content).html;
      }
    }

    return apresentacao.descricao;
  };

  return (
    <Wrapper>
      <Container>
        <PageTitle
          title={apresentacao.titulo}
          path={[
            {
              text: "Homepage",
              link: "/",
            },
            {
              text: "Ferramentas úteis",
              link: "/ferramentas-uteis",
            },
            {
              text: "Formação",
              link: "/ferramentas-uteis/formacao",
            },
            {
              text:
                window.location.href.includes("formacao-online") == 0
                  ? "Cursos e Congressos"
                  : "Formação Online",
              link: window.location.href.includes("formacao-online")
                ? "/ferramentas-uteis/formacao/formacao-online"
                : "/ferramentas-uteis/formacao/cursos-congressos",
            },
            {
              text: apresentacao.titulo,
            },
          ]}
          imageDesktop={apresentacao.url}
          imageMobile={apresentacao.url}
          imageAlt={apresentacao.titulo}
        />

        <FlexInRow>
          <FlexInColumn>
            <FlexInRow className="event-content">
              <Tab>
                <FlexInColumn gap="1.823vw">
                  {apresentacao?.data?.length > 0 && (
                    <FlexInColumn gap="0.833vw">
                      <span>
                        <FontAwesomeIcon
                          icon={faCalendar}
                          className="icon icon-location"
                        />
                        {apresentacao?.data}
                      </span>
                    </FlexInColumn>
                  )}
                </FlexInColumn>
              </Tab>
              {disclaimer === true && (
                <Tag
                  color="warning"
                  style={{
                    fontSize: "16px",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    maxWidth: "100%",
                    whiteSpace: "normal",
                    display: "inline-block",
                  }}
                >
                  O seu tipo de utilizador não possui permissão para visualizar
                  os links abaixo.
                </Tag>
              )}
              <div
                dangerouslySetInnerHTML={{ __html: getHtml() }}
                className="mb-10 content preview"
              />
            </FlexInRow>
          </FlexInColumn>
        </FlexInRow>
      </Container>
    </Wrapper>
  );
}
